import React, { useState } from 'react'
import styled from 'styled-components'
import colors from 'theme/colors'
import fonts from 'theme/fonts'
import sizes from 'theme/sizes'

export default function TextArea({
    name,
    register,
    validations,
    squired = false,
    marginTop,
    value,
    onChangeValue = () => false,
    ...props
}) {
    const [newValue, setNewValue] = useState(value);

    const toggleValue = (e) => {
        setNewValue(e);
        onChangeValue(e);
    };

    return (
        register ? (
            <StyledTextArea
                squired={squired}
                {...props}
                {...register(name, validations)}
                marginTop={marginTop}
                onChange={(e) => toggleValue(e.target.value)}
            />
        ) : (
            <StyledTextArea
                squired={squired}
                {...props}
                onChange={(e) => toggleValue(e.target.value)}
                marginTop={marginTop}
            />
        )

    )
}


const StyledTextArea = styled.textarea`
    width: 100%;
    resize: none;
    border: 2px solid ${colors.nightLight};
    border-radius: 60px;
    padding: ${sizes.normal} ${sizes.mini};
    font-weight: ${fonts.weight.bold};
    background: transparent;
    color: ${colors.night};
    outline: none;

    ${({ marginTop }) => marginTop && `
        margin-top: ${marginTop};
    `};
    
    ${({ squired }) => squired && `
        border: 1px solid ${colors.nightLight};
        border-radius: 4px !important;

        &:focus {
            border: ${sizes.preon} solid ${colors.night} !important; 
        }
    `};

    &:focus {
        border: ${sizes.quark} solid ${colors.night};
    }


    &::placeholder {
        color: ${colors.nightLight};
    }
`